import React from 'react'
import Container from 'components/Container'
import Cover from 'components/Cover'
import Button from 'components/Button'
import useSession from 'hooks/useSession'
import Header from 'apps/booking/components/Header'

import Footer from '../components/Footer'

export default function LoginPage() {
  const { clearSession } = useSession()
  return (
    <>
      <Header seoTitle="Logg inn feil" />

      <Cover
        title="Noe gikk galt med din innlogging"
        size="tight"
        preamble="Vi klarer ikke åpne bestillingsflyten din. Vennligst logg ut og prøv igjen. Om du opplever gjentakende problemer med dette vennligst ta kontakt med kommunen din."
      />
      <Container size="tight">
        <Button onClick={() => clearSession()} primary>
          Logg ut
        </Button>

        <Footer />
      </Container>
    </>
  )
}
